import { GenericObject, RouteType } from 'app/constants/GlobalTypes'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

type Props = {
  route: Pick<RouteType, 'key'>
}

export default function useTitle({ route }: Props) {
  const { formatMessage } = useIntl()

  const titlelizer = (values: GenericObject<string> = {}) => {
    const path = `page.${route.key}${
      Object.values(values).filter(Boolean).length ? '_with_values' : ''
    }`
    const translated = formatMessage({ id: path }, { ...values })
    document.title = `${translated}`
    return translated
  }

  const title = useMemo(() => titlelizer(), [route])

  return { title, titlelizer }
}
